import ProgressDonut from "../teacher/charts/ProgressDonut";
import StackedProgressBar from "../teacher/charts/StackedProgressBar";
import {
  DEMO_COHORT_LABEL,
  DEMO_COHORT_TEMPLATE,
  DEMO_PROGRESS_ROWS,
  demoProgressTotals,
} from "./demoData";

/**
 * Read-only cohort progress dashboard built from the same chart components the
 * teacher analytics pages use, so the look stays in sync automatically.
 */
export default function CohortProgressShowcase() {
  const totals = demoProgressTotals(DEMO_PROGRESS_ROWS);

  return (
    <div className="landing-cohort">
      <header className="landing-cohort-head">
        <div>
          <p className="landing-cohort-name">{DEMO_COHORT_LABEL}</p>
          <p className="muted small">{DEMO_COHORT_TEMPLATE} · 28 students</p>
        </div>
        <span className="landing-cohort-pill">{totals.passRate ?? 0}% complete</span>
      </header>

      <div className="landing-cohort-grid">
        <section className="submissions-chart-panel landing-cohort-donut">
          <h3 className="submissions-chart-title">Completion mix</h3>
          <p className="muted small submissions-chart-sub">All assigned lessons combined</p>
          <ProgressDonut
            complete={totals.complete}
            inProgress={totals.inProgress}
            needsHelp={totals.needsHelp}
            notStarted={totals.notStarted}
            passRate={totals.passRate}
          />
        </section>

        <section className="submissions-chart-panel submissions-chart-panel--wide landing-cohort-bars">
          <h3 className="submissions-chart-title">Progress by lesson</h3>
          <p className="muted small submissions-chart-sub">Where the class is cruising and where they&apos;re stuck</p>
          <div className="submissions-bars">
            {DEMO_PROGRESS_ROWS.map((row) => (
              <StackedProgressBar
                key={row.lessonTitle}
                label={row.lessonTitle}
                complete={row.complete}
                inProgress={row.inProgress}
                needsHelp={row.needsHelp}
                notStarted={row.notStarted}
              />
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}
